import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import postTasks from 'Api/host-task-submission/postTasks';
import { useStatusState } from 'Store/status-state';
import { useLoader } from 'Store/loader';

import postTasksPayload from './model/postTasksPayload';

const usePostTasks = ({ setError }) => {
  const { t } = useTranslation('host-content');
  const { onOpenStatusState } = useStatusState();
  const { onShowLoader, onResetLoader } = useLoader();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: async (data) => {
      const payload = postTasksPayload(data);
      onShowLoader({ variant: 'loader-primary' });

      const result = await postTasks(payload);

      return { response: result, payload };
    },
    onSettled: () => {
      onResetLoader();
    },
    onSuccess: ({ response, payload }) => {
      if (response.success) {
        onOpenStatusState({
          type: 'success',
          title: t('success.title'),
          description: t('success.description', { count: payload.videoUrls.length }),
          onClick: () => navigate('/host'),
        });
      }
    },
    onError: (error) => {
      const errorFields = error?.response?.data?.data?.validationUrls;

      if (errorFields?.length) {
        errorFields.forEach((field, index) => {
          if (field?.status !== 'VALID') {
            setError(`videoUrls.${index}.value`, {
              type: 'server',
              message: field?.status === 'DUPLICATE' ? t('error.link_already_in_use') : t('error.invalid_link'),
            });
          }
        });
      }
    },
  });
};

export default usePostTasks;
